import { gql } from "@apollo/client";

export default gql`
  mutation updateTopicAssigneeMutation(
    $topicId: Int
    $assignee: Int
    $meetingId: Int
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      assignee: $assignee
      meetingId: $meetingId
    ) {
      topic {
        id
        assignee {
          id
          name
          avatar
        }
      }
    }
  }
`;
